<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <panel-title icon title desc />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PanelTitle from "@/components/PanelTitle.vue";
export default {
  components: { PanelTitle }
};
</script>

<style>
</style>